exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-text {\n\tcolor: #06263e;\n\tfont-size: 1rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.07rem;\n\tbackground-color: transparent;\n}\n.row-content-dialog-details {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: 15px;\n\ttop: 0px;\n}\n.obj-pos-abs {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n}\n", ""]);

// exports
